export const pushDataLayerPromoFiltersEvent = (
  promoTripMonth?: string,
  promoLeaveFrom?: string,
  promoGoTo?: string,
  promoDuration?: string,
  promoStarRating?: string
) => {
  const formatStarRating = (rating?: string): string => {
    if (!rating) {
      return "";
    }
    return rating === "5" ? "5*" : `${rating}* & up`;
  };
  window.dataLayer.push({
    event: "promoFilters",
    promoTripMonth: promoTripMonth ?? "",
    promoLeaveFrom: promoLeaveFrom ?? "",
    promoGoTo: promoGoTo ?? "",
    promoDuration: promoDuration ?? "",
    promoStarRating: formatStarRating(promoStarRating),
  } as DataLayerPromoFilters);
};
export interface DataLayerPromoFilters {
  event: string;
  promoTripMonth: string;
  promoLeaveFrom: string;
  promoGoTo: string;
  promoDuration: string;
  promoStarRating: string;
}
